// extracted by mini-css-extract-plugin
module.exports = {"chatContainer":"Chat_chatContainer__2dOKN","chatList":"Chat_chatList__1CRm_","chatWindow":"Chat_chatWindow__FFcW5","spin360":"Chat_spin360__3YPb5"};